<template>
  <div class="sky-step-view-create-order-wrapper">
    <div style="padding-top: 16px;text-align: center; float: left; position: absolute;" class="wsp-display-flex">
      <div
        style="width: 6px;
          line-height: 28px;
          background-color: #0052d9;"
      ></div>
      <div
        style="font-size: 18px;
          line-height: 28px;
          padding-left: 12px;"
      >
        售前测试拓扑图
      </div>
    </div>
    <div class="order-topology">
      <div id="demo-vis-network" class="view-page"></div>
    </div>
    <div class="order-download">
      <div>
        <div class="order-icon">
          <div :class="`wsp-icon-word wsp-icon wsp-icon-status-${buildStatus}`"></div>
          <div v-if="buildStatus === 'success'" class="order-status text">
            <sk-icon-status type="success" :content="`【${projectCustomer} 】售前测试方案已生成`"></sk-icon-status>
          </div>
          <div v-else-if="buildStatus === 'pending'" class="order-status text">
            <sk-icon-status type="ing" content="测试方案生成中"></sk-icon-status>
          </div>
          <div v-else-if="buildStatus === 'error'" class="order-status text" @click="reSavePlanTopology">
            <sk-icon-status type="error" :content="`售前测试方案生成失败`"></sk-icon-status>
            <i class="el-icon-refresh"></i>
          </div>
        </div>
        <div class="order-result text" style="font-weight: bolder;">
          测试方案可下载后根据需求做个性修订或可点击处理按钮随时在线调整方案内容
        </div>
        <div class="order-result text font-color">请到样机系统进行测试方案上传</div>
        <div v-show="canDownload">
          <!-- <el-button type="primary">分享文档</el-button> -->
          <el-button type="success" @click="downloadDocument">下载Word</el-button>
          <el-button type="success" @click="downloadExcel">下载Excel</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { PLAN_MNG } from '@/api/apiModules'
import { getPlanTopology, savePlanTopology, getInstPlan } from '@/api/plan'

const vis = require('vis-network/dist/vis-network.min.js')
require('vis-network/dist/dist/vis-network.min.css')

export default {
  name: 'StepViewCreateOreder',
  components: {
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    data: {
      type: Object,
      default() {
        return null
      }
    }
  },
  mounted() {
    this.$emit('openChangeDialog', { projectId: this.data.projectId })
    this.getInItData()
    this.buildInterval()
    this.$emit('showBtns', {
      preStep: true,
      nextStep: false,
      saveStep: false,
      enableTabChange: false
    })
  },
  data: function() {
    return {
      projectCustomer: '',
      buildStatus: 'pending',
      canDownload: false,
      serverTopology: [],
      sceneTopology: [],
      topologyNodes: [],
      topologyEdges: []
    }
  },
  methods: {
    getData() {
      return {}
    },
    buildInterval() {
      var cnt = 0
      this.startTimer = setInterval(() => {
        cnt++
        if (cnt > 4) {
          this.canDownload = false
          this.buildStatus = 'error'
          clearInterval(this.startTimer)
          return
        }
        getInstPlan({ projectId: this.data.projectId }).then(res => {
          if (res.data.content.instPlan.length > 1) {
            this.buildStatus = 'success'
            this.canDownload = true
            this.projectCustomer = res?.data?.content?.projectCustomer
            clearInterval(this.startTimer)
          }
        })
      }, 2500)
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
      return true
    },
    getInItData() {
      this.buildStatus = 'pending'
      getPlanTopology({ projectId: this.data.projectId })
        .then(res => {
          this.serverTopology = res.data.content.serverTopology
          this.sceneTopology = res.data.content.sceneTopology
          this.buildTopology()

          setTimeout(() => {
            var base64 = this.getBase64()

            var re_back = base64.replace('data:image/png;base64,', '')
            var req_paras = {
              projectId: this.data.projectId,
              topologyImage: re_back
            }
            savePlanTopology(req_paras)
              .then(res => {})
              .catch(error => {
                this.buildStatus = 'error'
                this.canDownload = false
                clearInterval(this.startTimer)
              })
          }, 3000)
        })
        .catch(error => {
          this.buildStatus = 'error'
          this.canDownload = false
          clearInterval(this.startTimer)
        })
    },
    reSavePlanTopology() {
      this.getInItData()
      this.buildInterval()
    },
    downloadDocument() {
      this.$store.dispatch('customDownloadDocument', {
        module: PLAN_MNG,
        params: {
          id: this.data.projectId
        },
        action: 'downloadPlan'
      })
    },
    downloadExcel() {
      this.$store.dispatch('customDownloadDocument', {
        module: PLAN_MNG,
        params: {
          id: this.data.projectId
        },
        action: 'downloadPlanExcel'
      })
    },
    getBase64() {
      var canvas = document.getElementsByTagName('canvas')[0]
      var base64Image = canvas.toDataURL()
      return base64Image
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    buildTopology() {
      var serverLabel = ''
      this.topologyNodes = []
      for (const iterator of this.serverTopology) {
        serverLabel += iterator.server + '\r\n'
      }
      var serverId = this.guid()
      var serverNode = {
        id: serverId,
        label: serverLabel,
        image: require('../../../../../assets/images/server.png'),
        shape: 'image'
      }
      this.topologyNodes.push(serverNode)
      for (const sceneITEM of this.sceneTopology) {
        var sceneITEMId = this.guid()
        var sceneNode = {
          id: sceneITEMId,
          label: '交换机\t\n' + sceneITEM.sceneName,
          image: require('../../../../../assets/images/Switch.png'),
          shape: 'image'
        }
        this.topologyNodes.push(sceneNode)
        this.topologyEdges.push({ from: serverId, to: sceneITEMId, length: 360 })
        for (const clientItem of sceneITEM.clientTopologyDTOList) {
          var clientId = this.guid()
          var clientLabel = ''
          for (const iterator of clientItem.terminalTopologyDTOList) {
            clientLabel += iterator.terminal + ' \r\n'
          }
          var clientNode = {
            id: clientId,
            label: clientItem.client + '\r\n' + clientLabel,
            image: require('../../../../../assets/images/terminal.png'),
            shape: 'image'
          }
          this.topologyNodes.push(clientNode)
          this.topologyEdges.push({ from: sceneITEMId, to: clientId, length: 360 })
        }
      }
      this.globalTrace()
    },
    globalTrace() {
      var nodes = new vis.DataSet(this.topologyNodes)
      var edges = new vis.DataSet(this.topologyEdges)
      var container = document.getElementById('demo-vis-network')
      var data = {
        nodes: nodes,
        edges: edges
      }
      var options = {
        layout: {
          hierarchical: {
            direction: 'UD', //分层排序方向
            sortMethod: 'directed', //分层排序方法
            nodeSpacing: 300
          },
          physics: {
            hierarchicalRepulsion: {
              nodeDistance: 300
            }
          }
        }
      }
      this.network = new vis.Network(container, data, options)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-create-order-wrapper) {
  height: 100%;
  .order-topology {
    display: flex;
    margin-top: 36px;
    justify-content: center;
    text-align: center;
    .view-page {
      width: 90%;
      height: 60vh;
    }
  }

  .order-download {
    display: flex;
    justify-content: center;
    text-align: center;
    .order-icon {
      display: flex;
      .wsp-icon-status-success {
        color: #3bb113;
      }
      .wsp-icon-status-pending {
        color: #e69d01;
      }
      .wsp-icon-status-error {
        color: #ec2805;
      }
      .wsp-icon {
        font-size: 28px;
        padding: 0 12px;
        text-align: right;
      }
      .order-status {
        line-height: 28px;
      }
    }
    .text {
      line-height: 28px;
    }
    .font-color {
      color: #ec2805;
    }
  }
}
</style>
